/**
 * **NOTE** The utility in this file is a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

export const truncateText = (text = '', length: number) =>
  text?.length > length ? `${text.substring(0, length)}...` : text;
